import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    name: "电影",
    desc: "院线大片 · 经典佳片",
    tone: "bg-primary-500/90",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    name: "电视剧",
    desc: "热播国剧 · 海外剧集",
    tone: "bg-accent-500/90",
  },
  {
    to: "/category/variety",
    icon: "ri-mic-line",
    name: "综艺",
    desc: "真人秀 · 音乐竞演",
    tone: "bg-secondary-500/90",
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto -mt-10 max-w-[1400px] px-4 md:px-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4 transition-colors hover:border-accent-500/60 md:p-5"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg text-background-50 md:h-16 md:w-16 ${entry.tone}`}
            >
              <i className={`${entry.icon} text-2xl md:text-3xl`} aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                {entry.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{entry.desc}</p>
            </div>
            <i
              className="ri-arrow-right-line ml-auto text-xl text-foreground-500 transition-transform group-hover:translate-x-1 group-hover:text-accent-500"
              aria-hidden="true"
            ></i>
          </Link>
        ))}
      </div>
    </section>
  );
}